import { Layout, Section } from 'layout';
import { Redirect, Route, Switch, useRouteMatch } from 'react-router-dom';
import { AnalyticsOrderDashboardScreen } from './screens/analytics-order-dashboard-screen';
import { AnalyticsProductDashboardScreen } from './screens/analytics-product-dashboard-screen';
import { AnalyticsRestaurantDashboardScreen } from './screens/analytics-restaurant-dashboard-screen';
import { AnalyticsSupplierDashboardScreen } from './screens/analytics-supplier-dashboard-screen';
import { AnalyticsTransferDashboardScreen } from './screens/analytics-transfer-dashboard-screen';

const AnalyticsPage = () => {
  const match = useRouteMatch();

  return (
    <Layout type={'sidebar_page_layout'}>
      <Section name={'content'}>
        <Switch>
          <Redirect exact from={`${match.url}/`} to={`${match.url}/orders/dashboard`} />
          <Route path={`${match.url}/orders/dashboard`} component={AnalyticsOrderDashboardScreen} />
          <Route path={`${match.url}/transfers/dashboard`} component={AnalyticsTransferDashboardScreen} />
          <Route path={`${match.url}/restaurants/dashboard`} component={AnalyticsRestaurantDashboardScreen} />
          <Route path={`${match.url}/suppliers/dashboard`} component={AnalyticsSupplierDashboardScreen} />
          <Route path={`${match.url}/products/dashboard`} component={AnalyticsProductDashboardScreen} />
          <Route path='*' render={() => <Redirect to='/404' />} />
        </Switch>
      </Section>
    </Layout>
  );
};

export default AnalyticsPage;
